// extracted by mini-css-extract-plugin
module.exports = {"root":"Input_root__gidt0"};